function show3d() {
  //override default button click, uses event listeners instead
}
(function () {
  const nvznAppData = JSON.parse(document.getElementById('nvzn-app-data').textContent);
  if (!nvznAppData) return console.error('[NVZN] nvznAppData not found');
  log('nvznAppData:', nvznAppData);
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {
        const nvznID = nvznAppData.product.nvznID;
        if (!nvznID) return console.error('[NVZN] Product nvznID not found');
        // open viewer
        openNvzn3DPreview({
          nvznID: nvznID,
          language: nvznAppData.app.locale,
        });
      });
    });
  }
  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }
  init();
})();